import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=9f192024&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=9f192024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f192024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f192024')) {
      api.createRecord('9f192024', component.options)
    } else {
      api.reload('9f192024', component.options)
    }
    module.hot.accept("./Chips.vue?vue&type=template&id=9f192024&scoped=true&", function () {
      api.rerender('9f192024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Chips.vue"
export default component.exports